<template>
  <GfrLayout v-if="!accessTipsPopupShow">
    <GfrLayoutHeader class="app-layout-header pointer-events-auto">
      <div class="app-nav">
        <GfrLogo :link="`/${$route.params.lang}/`" class="app-logo">
          <img class="w-full" src="~@/assets/images/logo.svg" alt="Logo" />
        </GfrLogo>
        <div class="app-nav-right">
          <CommonMenu class="app-menu" />
          <CommonSearch v-if="searchStatus" class="app-search" />
          <CommonMultiLanguage
            v-if="langList.length > 1"
            class="app-language"
            :list="langList"
            :global="globalLang"
            only-self
          />
          <!--          <CommonDownload class="app-download" />-->
        </div>
      </div>
    </GfrLayoutHeader>
    <GfrLayoutMain class="app-layout-main">
      <slot />
    </GfrLayoutMain>
    <GfrLayoutFooter v-if="footType" :type="footType">
      <CommonContact
        v-if="socialList.length"
        class="app-footer-contact"
        :title="formatTransify('UGC_OFFICIAL_WEBSITE_FOOTER_FOLLOW')"
        :list="socialList"
      />
      <GfrLogo>
        <img class="app-footer-logo" src="@/assets/images/logo-garena.png" alt="" />
      </GfrLogo>
      <template #info>
        <CommonPolicyLinks v-if="privacyList.length" :list="privacyList" />
        <CommonCopyright v-if="copyRight" :content="copyRight" />
        <CommonLimits v-if="limits.length" :list="limits" />
      </template>
    </GfrLayoutFooter>
  </GfrLayout>
  <GfrLayout v-else>
    <client-only>
      <div class="app-access-tip-container">
        <CommonPopupAccessTipPopup
          v-model:show="accessTipsPopupShow"
          class="app-access-tip-container"
          :title="accessTipsInfo?.popup.title"
          :desc="accessTipsInfo?.popup.desc"
          :url="accessTipsInfo?.popup.url"
        />
      </div>
    </client-only>
  </GfrLayout>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import type { LanguageItem } from '../components/common/MultiLanguage/index.vue'
const { formatTransify } = useStore()
// config data
const { config, accessTipsInfo, accessTipsPopupShow } = storeToRefs(useStore())
// nav data
const footType = computed(() => config.value.footer.type)
// const footLanguage = computed(() => config.value.footer.language)
const globalLang = computed(() => config.value.lang_list.some((item) => item.region === 'GLOBAL'))
const langList = computed(() => {
  const list = config.value.lang_list
  const newList: LanguageItem[] = []
  list.forEach((item) => {
    newList.push({
      label: item.abbr,
      name: item.lang,
      region: item.region,
      id: item.id,
      default: item.is_default
    })
  })
  return newList
})
const socialList = computed(() => config.value.footer.social_media)
const privacyList = computed(() => config.value.footer.privacy_policy)
const copyRight = computed(() => config.value.footer.copyright)
const limits = computed(() => config.value.footer.age_limit)
const searchStatus = computed(
  () =>
    config.value.footer.search_status &&
    (config.value.footer.search_terms_documents || config.value.footer.search_terms_tutorial)
)
</script>
<style lang="scss" scoped>
.app-layout-header {
  @apply after:absolute after:bottom-0 after:left-0 after:w-full after:h-px after:bg-[#999]/25 max-lg:after:scale-y-50;
}

.app-nav {
  @apply flex h-full items-center justify-between;
  @apply max-2xl:px-5 lg:justify-start;
  @apply ltr:pl-27 ltr:pr-15 rtl:pl-15 rtl:pr-27;
}

.app-logo {
  @apply w-6 lg:mt-0.5 lg:w-8;
}

.app-nav-right {
  @apply flex h-full flex-1 items-center justify-end;
}

.app-menu {
  @apply order-2 lg:order-none lg:flex-1 max-2xl:px-10;
  @apply max-lg:px-0 max-2xl:px-10 max-xl:px-5 ltr:max-lg:ml-4 rtl:max-lg:ml-0 rtl:max-lg:mr-4;
  @apply ltr:2xl:pl-25 ltr:2xl:pr-6 rtl:2xl:pl-15 rtl:2xl:pr-25;
  @apply lg:mx-0 #{!important};
}

.app-download {
  @apply hidden lg:block;
}

// .app-search {
//   @apply ltr:lg:mr-6 ltr:mr-4 rtl:lg:ml-6 rtl:ml-4;
// }

.app-language {
  @apply ltr:ml-4 ltr:lg:ml-6 rtl:mr-4 rtl:lg:mr-6;
}

.app-layout-main {
  @apply pt-18 max-lg:pt-10;
}

.app-footer-logo {
  @apply w-[250px] max-lg:w-32;
}

.app-footer-contact {
  @apply lg:order-2 lg:mt-1 lg:max-w-[25%];
}

.app-access-tip-container {
  background-image: url('@/assets/images/access-tip-bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100vw;
  height: 100vh;
}

@media not all and (min-width: 1024px) {
  .app-access-tip-container {
    background-image: url('@/assets/images/access-tip-mobile-bg.jpg');
  }
}
</style>
